
import { Button, StatusScreen } from "@roberttamas/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <StatusScreen size="sm" title={t("notFound.title")} description={t("notFound.desc")}>
      <Button asChild className="w-full">
        <Link to="/sites">{t("sites.backToSites")}</Link>
      </Button>
    </StatusScreen>
  );
}
